// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1ts4X","name":"ConsentHeader_name__25a4D","birthday":"ConsentHeader_birthday__12fkd","skeleton":"ConsentHeader_skeleton__2RiWF"};